export default __webpack_public_path__ + "static/media/Concerto1.1c78957b.jpg";